<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_temp_list" v-if="!loading && section">
        <div class="pa-1">
          <v-card class="rounded_max mb-2" elevation="1">
            <div class="d-flex justify-space-between px-2">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    :to="`/section/inclass/${$route.params.idSection}/${$route.params.idCourse}`"
                    icon
                    ><v-icon>mdi-reply</v-icon></v-btn
                  >
                </template>
                <span>Back</span>
              </v-tooltip>
              <h3 class="mb-2">{{ $route.params.type }}</h3>
              <div v-if="readonly" class="mx-3"></div>
              <v-btn
                v-if="!readonly"
                icon
                color="red"
                @click="deleteModule($route.params.idModule)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
            <v-tabs
              centered
              :color="section.color"
              slider-size="4"
              v-model="tab"
            >
              <v-tab class="text-capitalize" href="#tab1">
                <b>Review</b>
              </v-tab>
              <v-tab class="text-capitalize" href="#tab2">
                <b>Module</b>
              </v-tab>
            </v-tabs>
          </v-card>
        </div>
        <v-tabs-items v-model="tab" style="background: none">
          <v-tab-item class="pa-1" value="tab1">
            <result-sync :readonly="readonly" />
          </v-tab-item>
          <v-tab-item class="pa-1" value="tab2">
            <div>
              <v-card
                class="rounded_max"
                elevation="1"
                style="overflow: hidden"
              >
                <div class="strip" :style="`background:${section.color}`">
                  <div style="height: 10px"></div>
                </div>

                <div class="px-5" v-if="dataSet.data">
                  <p class="default_txt mt-2">Module Title</p>
                  <v-text-field
                    :disabled="readonly"
                    placeholder="Type Here"
                    hide-details
                    v-model="dataSet.data.title"
                    :color="section.color"
                    style="font-size: 30px"
                    class="ma-0 pa-0"
                  ></v-text-field>

                  <p class="default_txt mt-5">Description</p>
                  <vue-editor
                    v-if="!readonly"
                    v-model="dataSet.data.description"
                    placeholder="Type Here"
                    :editor-toolbar="customToolbar"
                    @blur="updateModule"
                  />
                  <v-card class="pa-3" outlined v-else>
                    <p
                    class="mb-0"
                      v-html="
                        dataSet.data.description.replaceAll(/\n/g, '<br />')
                      "
                    ></p>
                  </v-card>
                  <!-- <v-textarea
                    :disabled="readonly"
                    dense
                    placeholder="Type Here"
                    v-model="dataSet.data.description"
                    hide-details
                    rows="2"
                    auto-grow
                    :color="section.color"
                  ></v-textarea> -->
                </div>
                <div class="pa-2 d-flex justify-end">
                  <p class="default_txt">{{ msg }}</p>
                </div>
              </v-card>

              <div>
                <v-card class="mt-3 pa-3 rounded_max" elevation="1">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <div class="pa-2 d-flex align-center">
                        <v-icon class="mr-2">mdi-link</v-icon>
                        <h4>Meeting Link</h4>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="pa-3">
                        <v-textarea
                          v-if="dataSet.detail.length"
                          hide-details
                          :filled="readonly"
                          :disabled="readonly"
                          class="mx-2"
                          :color="section.color"
                          label="Meeting Link"
                          placeholder="Put the link here"
                          rows="3"
                          outlined
                          v-model="dataSet.detail[0].content"
                          auto-grow
                        ></v-textarea>
                        <v-textarea
                          v-if="!dataSet.detail.length"
                          hide-details
                          :color="section.color"
                          :filled="readonly"
                          :disabled="readonly"
                          class="mx-2"
                          label="Meeting Link"
                          placeholder="Put the link here"
                          rows="3"
                          outlined
                          v-model="content"
                          auto-grow
                        ></v-textarea>
                        <v-btn
                          v-if="dataSet.detail.length"
                          dark
                          :color="section.color"
                          class="mt-3 mx-2 rounded-lg text-capitalize"
                          depressed
                          @click="openUrl(dataSet.detail[0].content)"
                          >Open URL di sync modul
                          <v-icon class="ml-2" small
                            >mdi-open-in-new</v-icon
                          ></v-btn
                        >
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="pa-2 d-flex align-center">
                        <v-icon class="mr-2">mdi-calendar-month-outline</v-icon>
                        <h4>Start Meeting</h4>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="pa-3">
                        <v-row no-gutters>
                          <v-col cols="12" md="7">
                            <div class="pa-2">
                              <p class="default_txt">Start Date</p>
                              <v-menu
                                :disabled="readonly ? true : false"
                                v-model="calendar"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-if="dataSet.detail.length > 0"
                                    v-model="dataSet.detail[0].session_date"
                                    placeholder="Click here"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    hide-details
                                    dense
                                  ></v-text-field>
                                  <v-text-field
                                    v-if="!dataSet.detail.length > 0"
                                    v-model="session_date"
                                    placeholder="Click here"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    hide-details
                                    dense
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-if="readonly && dataSet.detail.length > 0"
                                  readonly
                                  v-model="dataSet.detail[0].session_date"
                                  @input="calendar = false"
                                  :min="$date().format('YYYY-MM-DD')"
                                ></v-date-picker>
                                <v-date-picker
                                  v-if="!readonly && dataSet.detail.length > 0"
                                  v-model="dataSet.detail[0].session_date"
                                  @input="calendar = false"
                                  :min="$date().format('YYYY-MM-DD')"
                                ></v-date-picker>
                                <v-date-picker
                                  v-if="readonly && !dataSet.detail.length > 0"
                                  readonly
                                  v-model="session_date"
                                  @input="calendar = false"
                                  :min="$date().format('YYYY-MM-DD')"
                                ></v-date-picker>
                                <v-date-picker
                                  v-if="!readonly && !dataSet.detail.length > 0"
                                  v-model="session_date"
                                  @input="calendar = false"
                                  :min="$date().format('YYYY-MM-DD')"
                                ></v-date-picker>
                              </v-menu>
                            </div>
                          </v-col>

                          <v-col cols="12" md="5">
                            <div class="pa-2">
                              <p class="default_txt">Start Time</p>
                              <v-menu
                                :disabled="readonly ? true : false"
                                ref="menu1"
                                v-model="time"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-if="dataSet.detail.length > 0"
                                    v-model="dataSet.detail[0].session_time"
                                    placeholder="Click Here"
                                    append-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    dense
                                    v-on="on"
                                  ></v-text-field>
                                  <v-text-field
                                    v-if="!dataSet.detail.length > 0"
                                    v-model="session_time"
                                    placeholder="Click Here"
                                    append-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    dense
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="
                                    time &&
                                    readonly &&
                                    dataSet.detail.length > 0
                                  "
                                  readonly
                                  v-model="dataSet.detail[0].session_time"
                                  full-width
                                  @click:minute="
                                    $refs.menu1.save(
                                      dataSet.detail[0].session_time,
                                    )
                                  "
                                ></v-time-picker>
                                <v-time-picker
                                  v-if="
                                    time &&
                                    !readonly &&
                                    dataSet.detail.length > 0
                                  "
                                  v-model="dataSet.detail[0].session_time"
                                  full-width
                                  @click:minute="
                                    $refs.menu1.save(
                                      dataSet.detail[0].session_time,
                                    )
                                  "
                                ></v-time-picker>
                                <v-time-picker
                                  v-if="
                                    time &&
                                    readonly &&
                                    !dataSet.detail.length > 0
                                  "
                                  readonly
                                  v-model="session_time"
                                  full-width
                                  @click:minute="$refs.menu1.save(session_time)"
                                ></v-time-picker>
                                <v-time-picker
                                  v-if="
                                    time &&
                                    !readonly &&
                                    !dataSet.detail.length > 0
                                  "
                                  v-model="session_time"
                                  full-width
                                  @click:minute="$refs.menu1.save(session_time)"
                                ></v-time-picker>
                              </v-menu>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                  <v-overlay
                    :absolute="true"
                    color="white"
                    opacity="1"
                    :value="loading"
                  >
                    <v-progress-circular
                      indeterminate
                      class="mr-2"
                      color="#006341"
                    ></v-progress-circular>
                    <b class="color_default">Loading...</b>
                  </v-overlay>

                  <div class="d-flex justify-end mt-4" v-if="!readonly">
                    <v-btn
                      v-if="!loadingSave && !loading"
                      class="text-capitalize rounded-lg px-5"
                      depressed
                      dark
                      :color="section.color"
                      @click="assignSynchronous(dataSet.detail[0], true)"
                      >Save</v-btn
                    >
                    <v-btn
                      v-if="loadingSave"
                      :class="` text-capitalize rounded-lg`"
                      depressed
                      dark
                      :color="section.color"
                      >Loading</v-btn
                    >
                  </div>
                </v-card>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <div v-if="loading" class="_temp_list">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="pb-3">
              <v-skeleton-loader
                type="article"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="list-item-avatar-three-line"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="image"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="list-item-three-line"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="pa-3">
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import FormMaterial from "../formDetail/formMaterial.vue";
import FormScynchronous from "../formDetail/formSynchronous.vue";
import ResultSync from "../response/resultSync.vue";
export default {
  components: {
    FormMaterial,
    FormScynchronous,
    ResultSync,
  },
  name: "moduleSync",
  props: ["readonly"],

  data() {
    return {
      loading: true,
      loadingSave: false,
      dataSet: null,
      section: null,
      drag: false,
      sorted: [],
      sorting: false,
      msg: "",
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      isUpdate: false,
      updating: false,
      err: "",
      tab: "tab1",
      calendar: false,
      time: false,
      content: "",
      session_date: "",
      session_time: "",
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        ["link"],
        [{ color: [] }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      ],
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.fetchData();
    },
  },
  mounted() {
    this.fetchSection();
  },
  methods: {
    openUrl(link) {
      window.open(link, "_blank");
    },
    fetchSection() {
      this.loading = true;
      let data = {
        path: `manage/course/section?filter[id]=${this.$route.params.idSection}`,
      };
      this.$store.dispatch("course/getData", data).then((data) => {
        this.loading = false;
        this.section = data.data[0];
        this.fetchData(true);
      });
    },
    fetchData(first) {
      let module = this.$route.params.idModule;
      let instance = this.$route.params.idInstance;
      if (first) {
        this.loading = true;
      }
      let data = {
        path: `manage/course/section/module/${module}/${instance}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.dataSet = data;
          if (!data.detail.length) {
            this.tab = "tab2";
          }
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    deleteModule() {
      this.d_type = "d_module";
      this.d_title = "Delete Module";
      this.inventory = this.dataSet;
      this.d_small = true;
    },
    updateModule(item) {
      this.assignSynchronous(item, false);
    },
    assignSynchronous(item, loading) {
      if (loading) {
        this.loadingSave = true;
      } else {
        this.msg = "saving..";
      }
      this.err = "";
      let body = {
        course_synchronous_id: this.dataSet.data.id,
        title: this.dataSet.data.title,
        description: this.dataSet.data.description,
        content: item ? item.content : this.content,
        session_date: item ? item.session_date : this.session_date,
        session_time: item ? item.session_time : this.session_time,
      };
      let data = {
        path: `manage/course/section/synchronus/update/detail`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          if (!loading) {
            this.msg = "";
          }
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.fetchSection();
          this.loadingSave = false;
        })
        .catch((err) => {
          if (!loading) {
            this.msg = "Error";
          }
          var key = Object.keys(err.data.errors);
          var values = Object.values(err.data.errors);
          if (key.length == 0) {
            this.$store.dispatch("notify", {
              msg: err.message,
              type: "error",
            });
          }
          for (let i = 0; i < key.length; i++) {
            for (let j = 0; j < values[i].length; j++) {
              this.$toast.error(values[i][j]);
            }
          }
          this.loadingSave = false;
        });
    },
  },
};
</script>

<style scoped>
.strip {
  width: 100%;
  border-radius: 0 !important;
}
.card_gb {
  position: relative;
  overflow: hidden;
}
.icon_gb {
  position: absolute;
  right: -20px;
  bottom: -20px;
}
</style>
